export default __webpack_public_path__ + "static/media/quikstart-3.b4cb7fc1.svg";